import React from 'react';
import ObservationCard from './ObservationCard';
import styles from '../css/index.module.css';

const ObservationCardList = ({ observations = [], onCitationClick, sectionKicker }) => {
    if (!observations.length) return null;

    const kicker =
        sectionKicker != null && sectionKicker !== ''
            ? `${sectionKicker} (${observations.length})`
            : `Observation candidates (${observations.length})`;

    return (
        <section className={styles.aiWardenObservationSection} aria-label="Observation candidates">
            <span className={styles.aiWardenKicker}>{kicker}</span>
            <div className={styles.aiWardenObservationList}>
                {observations.map((obs, index) => (
                    <ObservationCard
                        key={obs.id || obs.title || `obs-${index}`}
                        observation={obs}
                        onCitationClick={onCitationClick}
                    />
                ))}
            </div>
        </section>
    );
};

export default ObservationCardList;
